module.exports = __webpack_public_path__ + "static/media/steffen.2a0c30ca.png";